import axios from "axios";
import { WEB_ROUTES } from "../WebEncryption";
import { ConsentApproveVerificationRequest } from "../../Models/Request/Consent/ConsentApprove";
import { ConsentUpdateVerificationRequest } from "../../Models/Request/Consent/UpdateConsent";

export function getConsentByConsentId(consentUniqueId: string) {
  return axios.get(`/User/Consent/${consentUniqueId}`);
}

export function getConsentByConsentHandle(consentUniqueId: string) {
  return axios.get(`/User/Consent/handle/${consentUniqueId}`);
}

export function consentApprovalInitiation(
  consentUniqueId: string,
  approvalStatus: string
) {
  return axios.post(
    `/User/Consent/Approval/${consentUniqueId}/${approvalStatus}`
  );
}

export function consentApprove(body: ConsentApproveVerificationRequest) {
  if (!body.accounts?.length) {
    delete body.accounts;
  }
  return axios.post(WEB_ROUTES.consentApprovalVerification, body, {
    headers: { medium: "WEB" },
  });
}

export function updateConsentStatus(consentId: string, status: string) {
  return axios.post(`/User/Consent/${consentId}/${status}`);
}

export function updateConsentStatusVerification(
  body: ConsentUpdateVerificationRequest
) {
  return axios.post(WEB_ROUTES.consentStatusVerification, body);
}

export function getPaginatedConsentByStatus(
  page: number,
  size: number,
  status: string
) {
  return axios.get(
    `/User/Consent?page=${page}&size=${size}&consentStatusType=${status}`
  );
}

export function getPaginatedConsentByConsentHandle(consentHandle: string) {
  return axios.get(`/User/Consent?consentHandle=${consentHandle}`);
}

export function getPaginatedConsentByConsentId(consentId: string) {
  return axios.get(`/User/Consent?consentId=${consentId}`);
}

export function getConsentCounts() {
  return axios.get(`/User/Consent/Count`);
}
